import React, { FC, PropsWithChildren } from 'react'
import { GridColumnProps, MarginBottomProps, MarginTopProps } from 'styled-system'
import { Box } from '../Layout'
import { AnimatedLabel } from './AnimatedLabel'
import { Text } from '@gassan-ui'
import { cn } from '@lib/cn'

export type FieldControlProps = PropsWithChildren<
  MarginBottomProps &
    MarginTopProps &
    GridColumnProps & {
      label?: React.ReactNode
      field: string
      assistiveText?: string
      errorMsg?: string
      htmlFor?: string
    }
>

export const FieldControl: FC<FieldControlProps> = ({
  label,
  assistiveText,
  errorMsg,
  children,
  field,
  mb = '1.5rem',
  htmlFor,
  ...rest
}) => {
  return (
    <Box {...rest} mb={mb}>
      {['input', 'textarea'].includes(field) ? (
        <Box position="relative">
          {children}
          {label && <AnimatedLabel htmlFor={htmlFor}>{label}</AnimatedLabel>}
        </Box>
      ) : (
        children
      )}
      {errorMsg ? (
        <Text variant="micro" className="mb-0 mt-2 text-error">
          {errorMsg}
        </Text>
      ) : assistiveText ? (
        <Text
          variant="micro"
          className={cn(
            'mb-0 mt-2 text-shade-500',
            ['checkbox', 'radio'].includes(field) ? 'pl-8' : '',
          )}
        >
          {assistiveText}
        </Text>
      ) : null}
    </Box>
  )
}

FieldControl.defaultProps = {
  mb: 3,
}
